import * as React from "react";
import { styled } from "styled-components";
import { File } from "@ludens-reklame/rubics-v3-sdk/file/types";

export interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  video?: File;
  videoUrl?: string;
  videoEmbed?: string;
}

export const VideoModal: React.FC<VideoModalProps> = ({
  isOpen,
  onClose,
  video,
  videoUrl,
  videoEmbed,
}) => {
  const embedUrl = videoUrl?.includes("watch?v=")
    ? videoUrl.replace("watch?v=", "embed/")
    : videoUrl;

  if (videoUrl && embedUrl && !embedUrl.includes("https://")) {
    console.error("Invalid videoUrl:", videoUrl);
  }

  React.useEffect(() => {
    if (typeof document !== "undefined" && isOpen) {
      document.body.onkeyup = function (event) {
        if (event.key === "Escape") {
          onClose();
        }
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>

        {video ? (
          <video src={video.url} controls>
            Your browser does not support the video tag.
          </video>
        ) : videoUrl ? (
          <iframe
            src={embedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : videoEmbed ? (
          <div
            className="embed"
            dangerouslySetInnerHTML={{ __html: videoEmbed }}
          />
        ) : null}
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  width: 80%;
  max-width: 1100px;
  position: relative;
  aspect-ratio: 16 / 9;

  iframe,
  video,
  .embed,
  .embed iframe {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
`;

const CloseButton = styled.div`
  position: absolute;
  top: -10px;
  right: -40px;
  font-size: 3rem;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
`;
